export default __webpack_public_path__ + "static/media/icon_menu_bare_metal_servers.4b52b9a4.svg";